import { ActionTypes } from "@/actions";
import fetchCollections from "@/app/api/componentsData";
import { call, put, select, takeEvery } from "redux-saga/effects";

const COMPONENTS_FRESH_MS = 120000; // 2 minutes

const workerComponentsRequest = function* (action: any): Generator<any, void, any> {
    try {
        const forceReload = Boolean(action?.payload?.force);

        const state = yield select();
        const existing = state?.components?.data;
        const lastFetchedAt = state?.components?.lastFetchedAt;
        const now = Date.now();

        // Only use cached components when the caller did not explicitly request a reload
        if (!forceReload &&
            Array.isArray(existing) &&
            existing.length > 0 &&
            typeof lastFetchedAt === "number" &&
            now - lastFetchedAt < COMPONENTS_FRESH_MS) {
            yield put({ type: ActionTypes.COMPONENTS_SUCCESS, payload: existing });
            return;
        }

        const response = yield call(fetchCollections);
        yield put({ type: ActionTypes.COMPONENTS_SUCCESS, payload: response });
    } catch (error: any) {
        console.error("Components saga: Failed to fetch components:", error?.message || error);
        yield put({ type: ActionTypes.COMPONENTS_FAILURE, payload: error?.message || "Failed to fetch components" });
    }
};

export function* watcherComponentsRequest() {
    yield takeEvery(ActionTypes.COMPONENTS_REQUEST, workerComponentsRequest);
}